export const initMovieModal = () => {
  // モーダルを開くボタンとモーダル本体を取得
  const modalBtn = document.querySelector('.movie-modal-btn');
  const movieModal = document.querySelector('.movie-modal');

  if (!modalBtn || !movieModal) return; // 存在しない場合は処理を中断

  // モーダルを開く処理
  modalBtn.addEventListener('click', (e) => {
    movieModal.classList.add('-active');
    // モーダルが開いている間、背景のスクロールを固定
    document.body.style.overflow = 'hidden';
    e.stopPropagation(); // イベントのバブリングを防止
  });

  // モーダル内の閉じるボタンの処理
  const closeBtn = movieModal.querySelector('button.close');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      movieModal.classList.remove('-active');
      // モーダルが閉じられたら背景のスクロールを復元
      document.body.style.overflow = 'auto';
      e.stopPropagation();
    });
  }

  // モーダル外をクリックした場合の処理
  document.addEventListener('click', (e) => {
    if (movieModal.classList.contains('-active')) {
      // movie-inner 内でクリックされなかった場合にモーダルを閉じる
      const movieInner = movieModal.querySelector('.movie-inner');
      if (movieInner && !movieInner.contains(e.target) && !e.target.closest('.movie-modal-btn')) {
        movieModal.classList.remove('-active');
        // モーダルを閉じたら背景のスクロールを復元
        document.body.style.overflow = 'auto';
      }
    }
  });
};
